import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const labelStyle = css`
	${theme.typography.eyebrow}
	margin: 0;
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly children: React.ReactNode;
};

/** The capitalized monospace section marker (`design-direction.md` §1), reused across every group of
 * a card so its style is defined once instead of repeated per group. */
const SectionLabel: React.FC<Props> = ({ children }) => {
	return <p css={labelStyle}>{children}</p>;
};

export default SectionLabel;
